"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadItem = exports.Upload = void 0;
const format_1 = require("../utils/format");
class Upload {
    constructor(dom) {
        this.dom = dom;
        this.items = [];
        this.container = this.dom.find('.item-container');
        this.addItem();
        this._isLoading = false;
        this.uploadForm = this.dom.find('#uploadForm');
        this.uploadInput = this.dom.find('#uploadFile');
        this.uploadText = this.dom.find('#uploadText');
        this.uploadIcon = this.dom.find('#uploadIcon');
        this.birthdayDisplay = this.dom.find('#birthday');
        this.uploadForm.on('submit', e => {
            e.preventDefault();
            e.stopPropagation();
            if (String(this.uploadInput.val()).trim().length == 0 || this._isLoading)
                return false;
            this.sendDocument();
            return false;
        });
        this.uploadInput.on('change', e => this.uploadForm.submit());
    }
    loading(on, text) {
        if (on) {
            if (text.trim().length)
                this.uploadText.text(text);
            this.uploadForm.addClass('loading');
            this.uploadIcon.removeClass('fa-file-upload').addClass('fa-file');
        }
        else {
            this.uploadForm.removeClass('loading');
            this.uploadIcon.removeClass('fa-file').addClass('fa-file-upload');
        }
        this._isLoading = on;
    }
    sendDocument() {
        this.loading(true, 'Datei wird hochgeladen...');
        this.birthdayDisplay.html('');
        this.container.html('');
        this.addItem();
        const formData = new FormData();
        const file = this.uploadInput.get(0).files[0];
        formData.append('document', file);
        $.ajax({
            url: this.uploadForm.attr('action'),
            data: formData,
            method: 'post',
            processData: false,
            contentType: false,
            success: result => {
                this.scanImages(file.name, result.images);
            }
        });
    }
    scanImages(filename, images) {
        this.loading(true, 'Datei wird gelesen...');
        $.ajax({
            url: '/scan',
            data: { images },
            method: 'post',
            success: result => {
                this.loading(false);
                if (typeof result === 'string') {
                    const name = result === 'UNKNOWN_DOCUMENT' ? 'Unbekannte Pensionskasse!' : result;
                    this.uploadText.html(`<b>${name}</b>`);
                    return;
                }
                this.container.html('');
                this.uploadText.html(`Pensionkassen-Auszug<br/>
                                      <b>${result.name}</b><br/>
                                      <span style="white-space: nowrap; text-overflow: ellipsis;">
                                      Datei: <span class="font-italic">${filename}</span></span>`);
                if (result.birthday)
                    this.birthdayDisplay.html('<b>Geburtsdatum:</b> ' + format_1.Format.date(new Date(result.birthday)) + '<hr/>');
                result.items.forEach(item => this.addItem(item));
            }
        });
    }
    addItem(itemData) {
        const item = new UploadItem(this, itemData);
        this.container.append(item.dom);
    }
    setPensionFundName(value) {
        this.dom.find('.card-header .title').text(value);
    }
}
exports.Upload = Upload;
class UploadItem {
    constructor(upload, { retirementAge, year, conversion, pension, savings } = {}) {
        this.upload = upload;
        this.nextAdded = false;
        this.createDom();
        this.ageDom = this.dom.find('.input-age');
        this.savingsDom = this.dom.find('.input-savings');
        this.conversionDom = this.dom.find('.input-conversion');
        this.pensionDom = this.dom.find('.input-pension');
        this.yearDom = this.dom.find('.input-year');
        if (typeof retirementAge === 'number')
            this.age = retirementAge;
        if (typeof savings === 'number')
            this.savings = savings;
        if (typeof conversion === 'number')
            this.conversion = conversion;
        if (typeof pension === 'number')
            this.pension = pension;
        if (typeof year === 'string')
            this.year = year;
        this.upload.items.push(this);
    }
    check(isManual) {
        if (this.age > 0 && this.savings > 0 && this.conversion > 0 && this.pension > 0) {
            if (isManual && !this.nextAdded) {
                this.nextAdded = true;
                this.upload.addItem({ retirementAge: this.age + 1, conversion: this.conversion });
            }
        }
    }
    createDom() {
        this.dom = $('' +
            '<div class="row">\n' +
            '    <div class="col age">\n' +
            '        <input name="retirementAge" inputmode="numeric" pattern="[0-9]*" type="text"\n' +
            '               class="form-control validate input-age" readonly placeholder="-" required>\n' +
            '    </div>\n' +
            '    <div class="col savings">\n' +
            '        <input name="savings" inputmode="numeric" pattern="[0-9]*" type="text"\n' +
            '               class="form-control validate input-savings" readonly placeholder="No Data" required>\n' +
            '    </div>\n' +
            '    <div class="col conversion">\n' +
            '        <input name="conversion" inputmode="numeric" pattern="[0-9]*"\n' +
            '               type="text" class="form-control validate input-conversion" readonly placeholder="No Data"\n' +
            '               required>\n' +
            '    </div>\n' +
            '    <div class="col pension">\n' +
            '        <input name="annual" inputmode="numeric" pattern="[0-9]*" type="text"\n' +
            '               class="form-control validate input-pension" readonly placeholder="No Data" required>\n' +
            '    </div>\n' +
            '    <div class="col year">\n' +
            '        <input name="year" inputmode="numeric" pattern="[0-9]*" type="text"\n' +
            '               class="form-control validate input-year" readonly placeholder="No Data" required>\n' +
            '    </div>\n' +
            '</div>');
    }
    get age() {
        return this._age;
    }
    set age(value) {
        this._age = value;
        this.ageDom.val(this._age.toString(10));
    }
    get savings() {
        return this._savings;
    }
    set savings(value) {
        this._savings = value;
        this.savingsDom.val(format_1.Format.currency(this._savings));
    }
    get conversion() {
        return this._conversion;
    }
    set conversion(value) {
        this._conversion = value;
        this.conversionDom.val(format_1.Format.percent(this._conversion));
    }
    get pension() {
        return this._pension;
    }
    set pension(value) {
        this._pension = value;
        this.pensionDom.val(format_1.Format.currency(this._pension));
    }
    get year() {
        return this._year;
    }
    set year(value) {
        this._year = value;
        this.yearDom.val(this._year);
    }
}
exports.UploadItem = UploadItem;
